import React from "react";
import { AdornmentText } from "./styled";
import { jsx as _jsx } from "react/jsx-runtime";
export default function TextAdornment(_ref) {
  var text = _ref.text,
    side = _ref.side;
  return /*#__PURE__*/_jsx(AdornmentText, {
    side: side,
    children: text
  });
}